/* unplugin-vue-components disabled */import script from "./BindMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./BindMobile.vue?vue&type=script&setup=true&lang=js"

import "./BindMobile.vue?vue&type=style&index=0&id=ca4af392&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca4af392"]])

export default __exports__